import React from 'react';
import {
    Avatar,
    Box,
    Button,
    Card,
    Chip,
    Stack,
    Typography,
    useTheme,
} from "@mui/material";
import {
    AccountBalanceWalletRounded,
    CardGiftcardRounded,
    CheckCircleRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const _DashWelcome = ({ corporate }) => {
    const navigate = useNavigate();
    const theme = useTheme();

    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour >= 5 && hour < 12) return "صبح بخیر";
        if (hour >= 12 && hour < 17) return "ظهر بخیر";
        if (hour >= 17 && hour < 21) return "عصر بخیر";
        return "شب بخیر";
    };

    const companyName = corporate?.Name || corporate?.CompanyName || "سازمان گرامی";

    return (
        <Card
            elevation={0}
            sx={{
                p: { xs: 2.5, md: 3.5 },
                borderRadius: 4,
                position: 'relative',
                overflow: 'hidden',
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.03)',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { xs: 'flex-start', md: 'center' },
                    justifyContent: 'space-between',
                    gap: 3,
                    position: 'relative',
                    zIndex: 1,
                }}
            >
                {/* اطلاعات سازمان و پیام خوش‌آمد */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Avatar
                        src={corporate?.Logo?.Url}
                        alt={companyName}
                        sx={{
                            width: { xs: 58, md: 72 },
                            height: { xs: 58, md: 72 },
                            borderRadius: 3.5,
                            bgcolor: 'primary.main',
                            color: '#ffffff',
                            fontWeight: 800,
                            fontSize: '1.5rem',
                            boxShadow: '0 8px 20px rgba(45, 107, 226, 0.25)',
                            border: '3px solid #ffffff',
                        }}
                    >
                        {companyName.slice(0, 1)}
                    </Avatar>

                    <Box>
                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5, justifyContent: 'flex-start' }}>
                            <Typography
                                variant="caption"
                                sx={{
                                    color: 'primary.main',
                                    fontWeight: 700,
                                    fontSize: '0.85rem',
                                }}
                            >
                                {getGreeting()}،
                            </Typography>
                            <Chip
                                icon={<CheckCircleRounded sx={{ fontSize: '14px !important', color: '#10b981 !important' }} />}
                                label="سازمان فعال"
                                size="small"
                                sx={{
                                    height: 22,
                                    fontSize: '0.72rem',
                                    fontWeight: 700,
                                    bgcolor: 'rgba(16, 185, 129, 0.1)',
                                    color: '#059669',
                                    border: '1px solid rgba(16, 185, 129, 0.25)',
                                }}
                            />
                        </Stack>

                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 900,
                                fontSize: { xs: '1.3rem', md: '1.65rem' },
                                color: 'text.primary',
                                mb: 0.6,
                                letterSpacing: '-0.02em',
                            }}
                        >
                            {companyName}
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.secondary',
                                fontSize: '0.85rem',
                                lineHeight: 1.6,
                            }}
                        >
                            سامانه مدیریت رفاهی و اعتبارات پرسنل
                        </Typography>
                    </Box>
                </Box>

                {/* دو دکمه اقدام سریع و اصلی (۲ CTA کلیدی) */}
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={2}
                    sx={{
                        width: { xs: '100%', md: 'auto' },
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        startIcon={<AccountBalanceWalletRounded />}
                        onClick={() => navigate("/finance/wallet")}
                        sx={{
                            borderRadius: 3,
                            py: 1.3,
                            px: 3.2,
                            fontWeight: 800,
                            fontSize: '0.92rem',
                            boxShadow: '0 8px 20px rgba(45, 107, 226, 0.3)',
                        }}
                    >
                        افزایش موجودی سازمان
                    </Button>

                    <Button
                        variant="contained"
                        color="secondary"
                        size="large"
                        startIcon={<CardGiftcardRounded />}
                        onClick={() => navigate("/allocations")}
                        sx={{
                            borderRadius: 3,
                            py: 1.3,
                            px: 3.2,
                            fontWeight: 800,
                            fontSize: '0.92rem',
                            bgcolor: 'secondary.main',
                            color: '#ffffff',
                            '&:hover': {
                                bgcolor: 'secondary.dark',
                            },
                            boxShadow: '0 8px 20px rgba(36, 183, 143, 0.25)',
                        }}
                    >
                        تخصیص اعتبار به پرسنل
                    </Button>
                </Stack>
            </Box>
        </Card>
    );
};

export default _DashWelcome;
